import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Search, Home, TrendingUp, Music2, Headphones } from 'lucide-react';

export default function NotFoundPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  function handleSearch(e: React.FormEvent) {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
    }
  }

  return (
    <>
      <Helmet>
        <title>Pagina no encontrada | LyricsHub</title>
        <meta name="description" content="La pagina que buscas no existe en LyricsHub." />
      </Helmet>

      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
        {/* Music-themed illustration */}
        <div className="relative mb-8">
          <div className="w-32 h-32 rounded-full bg-primary/10 flex items-center justify-center">
            <Headphones size={56} className="text-primary" />
          </div>
          <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-surface-hover flex items-center justify-center animate-bounce">
            <Music2 size={16} className="text-text-muted" />
          </div>
        </div>

        <h1 className="text-4xl font-bold text-text-primary mb-2">404</h1>
        <p className="text-xl text-text-secondary mb-2">Esta cancion no existe... todavia</p>
        <p className="text-text-muted mb-8 max-w-md">
          No encontramos la pagina que buscas. Quizas puedas encontrar lo que necesitas con una
          busqueda.
        </p>

        {/* Search */}
        <form onSubmit={handleSearch} className="relative w-full max-w-md mb-8">
          <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-text-muted" />
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Buscar canciones, artistas..."
            className="w-full pl-11 pr-4 py-3 rounded-xl bg-surface border border-border text-text-primary placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition-all"
          />
        </form>

        {/* Suggested Links */}
        <div className="flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-surface border border-border text-sm text-text-secondary hover:text-primary hover:border-primary/30 transition-colors"
          >
            <Home size={16} />
            Inicio
          </Link>
          <Link
            to="/charts/weekly"
            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-surface border border-border text-sm text-text-secondary hover:text-primary hover:border-primary/30 transition-colors"
          >
            <TrendingUp size={16} />
            Trending
          </Link>
          <Link
            to="/genres"
            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-surface border border-border text-sm text-text-secondary hover:text-primary hover:border-primary/30 transition-colors"
          >
            <Music2 size={16} />
            Generos
          </Link>
        </div>
      </div>
    </>
  );
}
